import { useQuery } from '@tanstack/react-query';
import { fetchSpotlights } from '../api/spotlights';
import { Spotlight } from '../types/spotlights';
import { isCurrentlyActive } from '@/lib/date-utils';

export function useSpotlights() {
  return useQuery<Spotlight[]>({
    queryKey: ['spotlights'],
    queryFn: async () => {
      const response = await fetchSpotlights();
      // Filter to only return spotlights that are currently active
      return response.data.filter((spotlight) =>
        isCurrentlyActive(spotlight.SpotlightStartDate, spotlight.SpotlightEndDate)
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}
